module.exports = __webpack_public_path__ + "img/Color 323.ba944877.jpg";